import { RgbaColor } from '../../content/models/LessonComponentStyle';

class ColorPickerService {

  /** Cache of lightened colors, keyed by primary color name. */
  private lights = new Map<string, string>();

  /* Referred here https://css-tricks.com/converting-color-spaces-in-javascript/ for rgbatoHex and hexToRgba conversion */
  public rgbToHex(color: RgbaColor) {
    const values = [color.r, color.g, color.b, Math.round(color.a * 255)];
    const stringValues = values.map((value) => {
      const _value = value.toString(16);
      return _value.length === 1 ? `0${_value}` : _value;
    });
    return `#${stringValues.join('')}`;
  }

  /* Removes the alpha value from the hex color string.
     eg. #rrggbbaa --> #rrggbb or #rgba --> #rgb 
  */
  public getColorComponent(color: string) {
    let value = color;
    if (color.length === 9) {
      value = color.slice(0, -2);
    }
    if (color.length === 5) {
      value = color.slice(0, -1);
    }
    return value;
  }
  
  public hexToRgbA(hex: string) {
    // Convert the first 2,3 characters to hexadecimal
    const r = parseInt(hex.substring(1, 3), 16);
    // Convert the next 4,5 characters to hexadecimal
    const g = parseInt(hex.substring(3, 5), 16);
    // Convert the last 6,7 characters to hexadecimal
    const b = parseInt(hex.substring(5, 7), 16);
    let a = 1;
    // Opacity is included
    if (hex.length > 7) {
      const opacity = parseInt(hex.substring(7, 9), 16);
      a = +(opacity / 255).toFixed(4);
    }
    return { r, g, b, a };
  };
 
  public changeOpacity(color: string, opacity: number): string {
    let colorValues = color;
    if (color.length > 7) {
      colorValues = color.substring(0, 7);
    }
    const reExp = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;
    const isValidColor = reExp.test(colorValues);
    if (isValidColor) {
      const calculatedOpacity = Math.round(
        Math.min(Math.max(opacity || 1, 0), 1) * 255
      );
      return colorValues + calculatedOpacity.toString(16);
    } else {
      return color;
    }
  };

  /** Returns the requested color, lightened to 20%. */
  public toLight(mainColor: string): string {
    //Remove alpha value from hex color code if found
    const main = this.getColorComponent(mainColor);
    if (!this.lights.has(main)) {
      let match: RegExpMatchArray;
      let rgb: number[];
      if ((match = main.match(/^#(\w{2})(\w{2})(\w{2})$/))) {
        rgb = match.slice(1).map((cc) => parseInt(cc, 16));
      } else if ((match = main.match(/^#(\w)(\w)(\w)$/))) {
        rgb = match.slice(1).map((c) => parseInt(`${c}${c}`, 16));
      }
      this.lights.set(main, rgb && `rgba(${rgb.join(',')},0.20)`);
    }
    return this.lights.get(main);
  }
}
export default new ColorPickerService();
